<!--hw-h5-order-pay-->

<template>
  <div>去支付 ...</div>
</template>

<script>
import request from "@/util/axios"
import { ORDER_TYPE_HW_H5 } from "@/api/constant"
import { Toast, Dialog } from "vant"

import {
  get_hw_h5_order,
  hw_h5_order_info_for_pay,
} from "@/views/user-center/select-card-pay/hw-h5-order"

import { mall_orders_create } from "@/api/goods-api"

import { ORDER_INFO_CACHE_KEY } from "@/util/XiZhangUtil"

export default {
  mounted() {
    request.post("/v5/provider-current").then((res) => {
      var payMode = res?.data?.payMode; // 支付方式

      // 西藏 这里创建订单
      if ("API_xizang" == payMode) {
        this.xizang_create_order_go_pay();

        return;
      }

      // 默认 RC 下一步 选了卡 再创建订单
      this.go_select_card_pay();
    });
  },

  methods: {
    xizang_create_order_go_pay() {
      Toast("创建订单 ..");

      get_hw_h5_order(this.$route.query.tradeno).then((res) => {
        budo_log.info("#24 get_hw_h5_order", res);

        var cacheKey = ORDER_INFO_CACHE_KEY;
        sessionStorage.setItem(cacheKey, JSON.stringify(res));

        var _order_info_ = hw_h5_order_info_for_pay([]);

        // 创建订单 去支付
        mall_orders_create(_order_info_).then((res) => {
          budo_log.info("#31 mall_orders_create", res);

          if (res?.data) {
            location.href = "/v4/api-pay?orderId=" + res.data;
          }
        });
      });
    },

    go_select_card_pay() {
      if (!this.$route.query.tradeno) {
        Dialog.alert({ message: "#56 hw h5 no query.tradeno" });
        return;
      }

      Toast("去支付 ...");

      var _this = this;

      this.$router.push({
        path: "/select-card-pay",
        query: {
          cateId: _this.$route.query.cateId,
          goodsType: ORDER_TYPE_HW_H5,
          tradeno: _this.$route.query.tradeno,
        },
      });
    },
  },
};
</script>
